import React, {useState, useEffect, useContext} from 'react';
import {useTranslation} from 'react-i18next';

import NotFound from '../../../NotFound';
import SelectComponent from '../../../Selects/SelectFilter';
import InputFilter from '../../../Filters/InputFilter';
import Datepicker from 'react-tailwindcss-datepicker';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import PopupPDF from './popUpPdf';
import AttachFileRoundedIcon from '@mui/icons-material/AttachFileRounded';
import {getContaCorrente, getEstabelecimentos, getMoedas, getPdf, getRepresentantes} from '../../../../pages/requests';
import LoadingModal from '../../../LoadingModal';
import {Context} from '../../../../Helpers/Auth';
import axios from 'axios';
import moment from 'moment';
import TablePagination from '../../../TablePagination';
import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined';

function ContaCorrente({info}) {
    const {t} = useTranslation();
    const {
        prospect,
        contaCorrente,
        setContaCorrente,
        utilizador,
        filtroSociedade,
        setFiltroSociedade,
        filtroEstab,
        setFiltroEstab,
        filtroEndereco,
        setFiltroEndereco,
        filtroDtFatura,
        setFiltroDtFatura,
        filtroDtVencimento,
        setFiltroDtVencimento,
        filtroRep,
        setFiltroRep,
        filtroValor,
        setFiltroValor,
        filtroValorPendente,
        setFiltroValorPendente,
        filtroNumDoc,
        setFiltroNumDoc,
        filtroDivisa,
        setFiltroDivisa,
        representantes,
        setRepresentantes,
        estabelecimentos,
        setEstabelecimentos,
        divisas,
        setDivisas,
    } = info;
    const [semDadosEstado, setSemDadosEstado] = useState(false);
    const [semDados, setSemDados] = useState(false);
    const [dataPdf, setDataPdf] = useState('');
    const [loading, setLoading] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [totalRegistos, setTotalRegistos] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);

    const [total, setTotal] = useState(0);
    const [totalVencido, setTotalVencido] = useState(0);
    const [totalNVencido, setTotalNVencido] = useState(0);

    const ITEMS_PER_PAGE = 15;
    const FORMATO_DATA = 'YYYY-MM-DD';

    const idiomaAtual = localStorage.getItem('i18nextLng');
    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') {
        lang = 'EN';
    }else if (idiomaAtual == 'es') {
        lang = 'ES'; 
    }

    const handleResize = () => {
        setIsMobile(window.innerWidth < 900);
    };

    // // FILTROS

    // const [filtroSociedade, setFiltroSociedade] = useState("");
    // const [filtroEstab, setFiltroEstab] = useState("");
    // const [filtroEndereco, setFiltroEndereco] = useState("");
    // const [filtroDtFatura, setFiltroDtFatura] = useState({
    //   startDate: "",
    //   endDate: "",
    // });
    // const [filtroDtVencimento, setFiltroDtVencimento] = useState({
    //   startDate: "",
    //   endDate: "",
    // });
    // const [filtroRep, setFiltroRep] = useState("");
    // const [filtroValor, setFiltroValor] = useState("");
    // const [filtroValorPendente, setFiltroValorPendente] = useState("");
    // const [filtroNumDoc, setFiltroNumDoc] = useState("");
    // const [filtroDivisa, setFiltroDivisa] = useState("");

    // // ARRAYS

    // const [representantes, setRepresentantes] = useState([]);
    // const [estabelecimentos, setEstabelecimentos] = useState([]);
    // const [divisas, setDivisas] = useState([]);

    const {isCard, openCards, formatarNumero} = useContext(Context);

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        getRepresentantes(lang).then(res => {
            setRepresentantes(res.data.representantes);
        });

        getEstabelecimentos(lang).then(res => {
            setEstabelecimentos(res.data.estabelecimentos);
        });

        getMoedas(lang).then(res => {
            setDivisas(res.data.moedas);
        });
    }, []);

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;

        const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
        const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;
        debugger;
        getContaCorrente(
            prospect?.codigoCliente,
            lang,
            signal,
            indexOfFirstItem,
            indexOfLastItem - 1,
            filtroRep?.value ?? '',
            filtroEstab?.value ?? '',
            filtroDtFatura.startDate,
            !isNaN(filtroValor) ? Number(filtroValor) : 0,
            filtroDivisa?.value ?? '',
            filtroNumDoc,
            filtroDtVencimento.startDate,
            !isNaN(filtroValorPendente) ? Number(filtroValorPendente) : 0,
        )
            .then(function (response) {
                debugger;
                setTotal(response.data.total);
                setTotalVencido(response.data.totalVencido);
                setTotalNVencido(response.data.totalNVencido);
                setContaCorrente(response.data.conta);
                setTotalRegistos(response.data.registos);
            })
            .catch(error => {
                if (!axios.isCancel(error)) {
                    console.log(error);
                }
            });

        return () => {
            controller.abort();
        };
    }, [currentPage, filtroRep, filtroEstab, filtroDtFatura, filtroValor, filtroDivisa, filtroNumDoc, filtroDtVencimento, filtroValorPendente]);

    function handleChangeFiltro() {
        if (filtroDivisa != '' || filtroRep != '' || filtroEstab != '') {
            return true;
        } else {
            return false;
        }
    }

    function limparFiltros(params) {
        setFiltroDivisa('');
        setFiltroRep('');
        setFiltroEstab('');
    }

    function handleGetPdf(produto) {
        setLoading(true);
        let vcrtyp = produto.vcrtyp;
        let id = produto.doc;
        getPdf(id, vcrtyp)
            .then(function (response) {
                if (response.data.success) {
                    setDataPdf(response.data.pdf);
                }
            })
            .finally(() => {
                setLoading(false);
            });
    }

    useEffect(() => {
        if (contaCorrente.length != 0 && semDadosEstado == false) {
            setSemDados(false);
        } else {
            setSemDados(true);
        }
    }, [contaCorrente]);

    // const formatarNumero = numero => {
    //     const partes = numero.toString().split('.');
    //     partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    //     partes[1] = partes[1] || '00';

    //     return partes.join(',');
    // };
    return (
        <>
            <div>
                {dataPdf != '' && <PopupPDF back={() => setDataPdf('')} id={dataPdf}></PopupPDF>}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 p-3 gap-3">
                    <div className="bg-blue-500 dark:bg-gray-800 shadow-lg rounded-[8px] flex items-center justify-between p-3 border-b-4 border-blue-600 dark:border-gray-600 text-white font-medium group">
                        <div className="flex justify-center items-center w-14 h-14 bg-white rounded-full transition-all duration-300 transform group-hover:rotate-12">
                            <RequestQuoteOutlinedIcon className="w-14 h-14 text-blue-800 dark:text-gray-800 transform transition-transform duration-500 ease-in-out" />
                        </div>
                        <div className="text-right">
                            <p>{t('totalVencido')}</p>
                            <p className="text-2xl">{formatarNumero(totalVencido)}</p>
                        </div>
                    </div>
                    <div className="bg-blue-500 dark:bg-gray-800 shadow-lg rounded-[8px] flex items-center justify-between p-3 border-b-4 border-blue-600 dark:border-gray-600 text-white font-medium group">
                        <div className="flex justify-center items-center w-14 h-14 bg-white rounded-full transition-all duration-300 transform group-hover:rotate-12">
                            <RequestQuoteOutlinedIcon className="w-14 h-14 text-blue-800 dark:text-gray-800 transform transition-transform duration-500 ease-in-out" />
                        </div>
                        <div className="text-right">
                            <p>{t('totalNVencido')}</p>
                            <p className="text-2xl">{formatarNumero(totalNVencido)}</p>
                        </div>
                    </div>
                    <div className="bg-blue-500 dark:bg-gray-800 shadow-lg rounded-[8px] flex items-center justify-between p-3 border-b-4 border-blue-600 dark:border-gray-600 text-white font-medium group">
                        <div className="flex justify-center items-center w-14 h-14 bg-white rounded-full transition-all duration-300 transform group-hover:rotate-12">
                            <RequestQuoteOutlinedIcon className="w-14 h-14 text-blue-800 dark:text-gray-800 transform transition-transform duration-500 ease-in-out" />
                        </div>
                        <div className="text-right">
                            <p>{t('total')}</p>
                            <p className="text-2xl">{formatarNumero(total)}</p>
                        </div>
                    </div>
                </div>

                {isMobile || isCard ? (
                    <div>
                        {contaCorrente?.map((produto, index) => (
                            <div key={index} className={`rounded-none border border-l-0 border-r-0 border-t-0 border-neutral-200 bg-white dark:border-neutral-600 dark:bg-gray-800`}>
                                <h2 className="mb-0" id="headingOne">
                                    <button
                                        className="group relative flex w-full font-medium items-center rounded-none border-0 bg-white px-5 py-1 text-left text-base text-neutral-800 transition [overflow-anchor:none] hover:z-[2] dark:bg-gray-800 text-primary   dark:text-white "
                                        type="button"
                                        data-te-collapse-init
                                        data-te-collapse-collapsed
                                        data-te-target={'#flush-collapseThree' + index}
                                        aria-expanded="false"
                                        aria-controls="flush-collapseThree">
                                        <span
                                            onClick={() => {
                                                handleGetPdf(produto);
                                            }}
                                            className="flex text-xs  items-center justify-center h-6 font-xs text-blue-600 rounded-[8px] hover:text-blue-800 dark:text-blue-500 dark:hover:text-blue-600 ">
                                            <AttachFileRoundedIcon />
                                        </span>
                                        <div className="flex flex-row">{produto.doc}</div>

                                        <span className="ml-auto h-5 w-5 shrink-0 rotate-[180deg] fill-[#336dec] transition-transform duration-200 ease-in-out group-[[data-te-collapse-collapsed]]:rotate-0 group-[[data-te-collapse-collapsed]]:fill-[#075baf] motion-reduce:transition-none dark:fill-blue-300 dark:group-[[data-te-collapse-collapsed]]:fill-white">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="h-6 w-6">
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                                            </svg>
                                        </span>
                                    </button>
                                </h2>
                                <div
                                    id={'flush-collapseThree' + index}
                                    className={openCards ? 'visible' : '!visible hidden'}
                                    data-te-collapse-item
                                    aria-labelledby="flush-headingThree"
                                    data-te-parent="#accordionFlushExample">
                                    <div className="px-5 py-4">
                                        {/* <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('sociedade')}:</div> {produto.sociedade}
                                        </div> */}
                                        {/* <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('estabelecimento')}: </div> {produto.estab}
                                        </div> */}
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('representante')}: </div> {produto.rep}
                                        </div>
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('dataFatura')}: </div> {produto.dataFatura}
                                        </div>
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('dataVenc')}: </div> {produto.dataVenc}
                                        </div>
                                        {/* <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('endereco')}: </div> {produto.end}
                                        </div> */}
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('valor')}: </div> {formatarNumero(produto.valor)}
                                        </div>
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('valorPendente')}: </div> {formatarNumero(produto.pendente)}
                                        </div>
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('divisa')}: </div> {produto.moeda}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}

                        {/* {loading && (
                            <div className="flex flex-row mt-14 justify-center">
                                <>
                                    <Spinner />
                                </>
                            </div>
                        )} */}
                        <nav className="flex items-center justify-between ml-4 pt-4" aria-label="Table navigation">
                            <div>
                                <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                                    {t('pagina')} <span className="font-semibold text-gray-900 dark:text-white">{currentPage}</span> {t('de')}{' '}
                                    <span className="font-semibold text-gray-900 dark:text-white">{Math.ceil(totalRegistos / ITEMS_PER_PAGE)}</span>
                                </span>

                                <span className="font-semibold ml-4 text-sm text-gray-900 dark:text-white">{totalRegistos}</span>
                                <span className="ml-2 mr-2 text-sm font-normal text-gray-500 dark:text-gray-400">{t('registos')}</span>
                            </div>
                            <TablePagination total={totalRegistos} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={page => setCurrentPage(page)} />
                        </nav>

                        <div className="mb-4">{semDados && <NotFound frase={t('semRegistos')} />}</div>
                    </div>
                ) : (
                    <>
                        <div className="relative mt-2 min-h-[400px] overflow-x-auto shadow-md sm:rounded-[8px]">
                            <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                                <thead className="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-600 dark:text-gray-300">
                                    <tr>
                                        <th scope="col" className="px-1 py-3"></th>
                                        <th scope="col" className="px-4 py-3">
                                            {t('representante')}
                                            <SelectComponent
                                                options={representantes}
                                                value={filtroRep ? filtroRep.label : ''}
                                                onChange={e => {
                                                    setFiltroRep(e.label);
                                                }}
                                                noOptionsMessage={t('semopcoes')}
                                                placeholder={t('filtro')}
                                            />
                                        </th>
                                        <th scope="col" className="px-6 py-3 ">
                                            {t('nDoc')}
                                            <InputFilter
                                                onSearch={value => {
                                                    setFiltroNumDoc(value);
                                                }}
                                            />
                                        </th>
                                        <th scope="col" className="px-6 py-3 ">
                                            {t('dataFatura')}
                                            <Datepicker
                                                displayFormat={FORMATO_DATA}
                                                useRange={false}
                                                asSingle={true}
                                                value={filtroDtFatura}
                                                onChange={newValue => {
                                                    setFiltroDtFatura(newValue);
                                                }}
                                                inputClassName={`rounded-[8px] mt-2 w-full bg-gray-50 border border-gray-300 text-xs text-gray-900 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 `}
                                            />
                                        </th>
                                        <th scope="col" className="px-6 py-3">
                                            {t('dataVenc')}
                                            <Datepicker
                                                displayFormat={FORMATO_DATA}
                                                // maxDate={today}
                                                useRange={false}
                                                asSingle={true}
                                                value={filtroDtVencimento}
                                                onChange={newValue => {
                                                    setFiltroDtVencimento(newValue);
                                                }}
                                                inputClassName={`rounded-[8px] mt-2 w-full bg-gray-50 border border-gray-300 text-xs text-gray-900 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 `}
                                            />
                                        </th>
                                        <th scope="col" className="px-6 py-3 ">
                                            {t('valor')}
                                            <InputFilter
                                                onSearch={value => {
                                                    setFiltroValor(value);
                                                }}
                                            />
                                        </th>
                                        <th scope="col" className="px-2 py-3 ">
                                            {t('valorPendente')}
                                            <InputFilter
                                                onSearch={value => {
                                                    setFiltroValorPendente(value);
                                                }}
                                            />
                                        </th>
                                        <th scope="col" className="px-6 py-3 ">
                                            {t('divisa')}
                                            <div className="flex flex-row">
                                                <SelectComponent
                                                    options={divisas}
                                                    value={filtroDivisa ? filtroDivisa.label : ''}
                                                    onChange={e => {
                                                        setFiltroDivisa(e.label);
                                                    }}
                                                    noOptionsMessage={t('semopcoes')}
                                                    placeholder={t('filtro')}
                                                />
                                                {handleChangeFiltro() ? (
                                                    <button
                                                        onClick={limparFiltros}
                                                        type="button"
                                                        className="flex items-center border-gray-300 text-gray-600 hover:text-blue-600 bg-gray-100 hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-[8px] ml-2 text-xs  text-center dark:bg-gray-600 dark:text-white dark:hover:text-blue-500 dark:focus:ring-blue-800">
                                                        <FilterAltOffIcon />
                                                    </button>
                                                ) : null}
                                            </div>
                                        </th>

                                        {/* <th scope="col" className="px-6 py-3">
                                            {t('estabelecimento')}
                                            <SelectComponent
                                                options={estabelecimentos}
                                                value={filtroEstab ? filtroEstab.label : ''}
                                                onChange={e => {
                                                    setFiltroEstab(e.label);
                                                }}
                                                noOptionsMessage={t('semopcoes')}
                                                placeholder={t('filtro')}
                                            />
                                        </th> */}
                                        {/* <th scope="col" className="px-6 py-3 ">
                                            {t('endereco')}
                                            <InputFilter
                                                onSearch={value => {
                                                    setFiltroEndereco(value);
                                                }}
                                            />
                                        </th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {contaCorrente.map(produto => (
                                        <tr className="odd:bg-white even:bg-gray-100 odd:dark:bg-gray-700 hover:border-2 border-b cursor-pointer dark:bg-gray-800 dark:border-gray-600 hover:border-amber-400 hover:dark:border-amber-400">
                                            <td className="px-2 py-1">
                                                <span
                                                    onClick={() => {
                                                        handleGetPdf(produto);
                                                    }}
                                                    className="flex text-xs  items-center justify-center h-6 font-xs text-blue-600 rounded-[8px] hover:text-blue-800 dark:text-blue-500 dark:hover:text-blue-600 ">
                                                    <AttachFileRoundedIcon />
                                                </span>
                                            </td>
                                            <th scope="row" className="px-4 py-1 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                                {produto.rep}
                                            </th>
                                            <td className="px-6 py-1">{produto.doc}</td>
                                            <td className="px-6 py-1">{moment(produto.dataFatura).format(FORMATO_DATA)}</td>
                                            <td className="px-6 py-1">{moment(produto.dataVenc).format(FORMATO_DATA)}</td>
                                            <td className="text-end text-blue-600 dark:text-blue-500 px-6 py-1">{formatarNumero(produto.valor)}</td>
                                            <td className="text-end text-blue-600 dark:text-blue-500 px-6 py-1">{formatarNumero(produto.pendente)}</td>
                                            <td className="px-6 py-1">{produto.moeda}</td>
                                            {/* <td className="px-6 py-1">{produto.estab}</td> */}
                                            {/* <td className="px-6 py-1">{produto.end}</td> */}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <div className="mb-4">{semDados && <NotFound frase={t('semRegistos')} />}</div>
                            <nav className="flex items-center justify-between ml-4 pt-4" aria-label="Table navigation">
                                <div>
                                    <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                                        {t('pagina')} <span className="font-semibold text-gray-900 dark:text-white">{currentPage}</span> {t('de')}{' '}
                                        <span className="font-semibold text-gray-900 dark:text-white">{Math.ceil(totalRegistos / ITEMS_PER_PAGE)}</span>
                                    </span>

                                    <span className="font-semibold ml-4 text-sm text-gray-900 dark:text-white">{totalRegistos}</span>
                                    <span className="ml-2 mr-2 text-sm font-normal text-gray-500 dark:text-gray-400">{t('registos')}</span>
                                </div>
                                <TablePagination total={totalRegistos} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={page => setCurrentPage(page)} />
                            </nav>
                        </div>
                    </>
                )}
            </div>
            {loading && (
                <div className="flex flex-row mt-14 justify-center">
                    <>
                        <LoadingModal />
                    </>
                </div>
            )}
        </>
    );
}

export default ContaCorrente;
